import React from 'react'
import {
  Pane,
  Button
} from '@leverege/ui-elements'
import classnames from 'classnames'
import S from './OccupancyGraphToggleButton.css'

export default function OccupancyGraphToggleButton( props ) {
  
  const { 
    setLwButtonActive,
    setUwButtonActive,
    setAllLinesActive,
    lwButtonActive,
    uwButtonActive,
    allLinesActive,
  } = props

  return (

    <Pane className={S.buttonContainer} layout="flex:row">  
      <Button variant="secondary"
        className={classnames( S.first, allLinesActive ? S.active : '', S.really, S.win )}
        onClick={() => {
          setLwButtonActive( false )
          setUwButtonActive( false )
          setAllLinesActive( true )
        }}>
        All Lines
      </Button>
      <Button variant="secondary"
        className={classnames( S.second, uwButtonActive ? S.active : '', S.really, S.win )}
        onClick={() => {
          setLwButtonActive( false )
          setUwButtonActive( true )
          setAllLinesActive( false )
        }}>
        Shell HP
      </Button>
      <Button variant="secondary"
        className={classnames( S.third, lwButtonActive ? S.active : '', S.really, S.win )}
        onClick={() => {
          setLwButtonActive( true )
          setUwButtonActive( false )
          setAllLinesActive( false )
        }}>
        Shell LP
      </Button>
      
    </Pane>
  )
}
